// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../assets/images/confetti.png";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3sz7GhpB9VJr4AX12xjjop{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");height:100%;display:flex;align-items:center;justify-content:center;animation:_2WzgBNBtqTFOjfYAad_c4j 500s linear infinite}@keyframes _2WzgBNBtqTFOjfYAad_c4j{from{background-position:0 0}to{background-position:0 10000px}}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confetti": "_3sz7GhpB9VJr4AX12xjjop",
	"animatedBackground": "_2WzgBNBtqTFOjfYAad_c4j"
};
export default ___CSS_LOADER_EXPORT___;
